import { getObj } from './localStorage';
import { getUserLanguage } from './language';

export const convertValueToCurrency = (price, showCurrency = false, currency = null, minDecimals = 2) => {
  const parsePrice = parseFloat(price) / 100;

  // Priority: explicitly passed currency > order currency > default EUR
  // If currency is explicitly passed (not null), always use it
  const effectiveCurrency = currency || getObj('order')?.currency || 'EUR';

  // Default: two decimals so prices that are listed, compared, or summed into a
  // total (checkout/receipt line items, plan cards, gift options) line up
  // ("€12,00", "€3,20"). Pass minDecimals = 0 for a genuinely standalone whole
  // price that reads cleaner without trailing zeros ("€12"). Note: standalone
  // marketing prices ("from €10") don't use this helper — the static site has
  // its own formatMoney/priceShort in site/scripts/product-tokens.js.
  const currencyOptions = {
    style: 'currency',
    currency: effectiveCurrency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: 2,
  };

  const nonCurrencyOptions = { minimumFractionDigits: minDecimals, maximumFractionDigits: 2 };

  const options = showCurrency ? currencyOptions : nonCurrencyOptions;
  const language = getUserLanguage();

  return parsePrice.toLocaleString(language, options);
};
